import React, { FC, useEffect, useRef, useState } from 'react';
import { DraggableEvent } from 'react-draggable';
import { Rnd } from 'react-rnd';
import { MainCont } from './DragAndResizable.styles';
import { useGesture } from '@use-gesture/react';

enum Axis {
  Y = 'Y',
  X = 'X',
}

interface IDragAndResizable {
  id: number;
  initialPositionX: number;
  initialPositionY: number;
  initialSizeY: number;
  initialSizeX: number;
  style?: object;
  lockAspectRatio?: boolean;
  children: React.ReactNode;
  parentElem: React.RefObject<HTMLDivElement>;
  toggleDrag: (id?: number, e?: DraggableEvent) => void;
  handleZIndex: (id: number) => void;
}

interface IRnd {
  scale: {
    w: number;
    h: number;
  };
  position: {
    x: number;
    y: number;
  };
}

const DragAndResizable: FC<IDragAndResizable> = ({
  id,
  initialPositionX,
  initialPositionY,
  initialSizeY,
  initialSizeX,
  children,
  parentElem,
  lockAspectRatio,
  style,
  toggleDrag,
  handleZIndex,
}) => {
  const rndComponent = useRef<Rnd>(null);
  const cardElem = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState(16);

  const [rndState, setRndState] = useState<IRnd>({
    scale: {
      w: initialSizeX,
      h: initialSizeY,
    },
    position: {
      x: initialPositionX,
      y: initialPositionY,
    },
  });

  // const calculatePercentage = (data: DraggableData, axis: Axis) => {
  //   if (data.node.parentElement?.clientWidth && data.node?.clientWidth) {
  //     if (axis === Axis.Y) {
  //       const offSet = data.node.parentElement?.clientHeight - data.node?.clientHeight;
  //       const finalHeight = data.node.parentElement?.clientHeight - offSet;
  //       return data.y / finalHeight * 100
  //     } else if (axis === Axis.X) {
  //       const offSet = data.node.parentElement?.clientWidth - data.node?.clientWidth;
  //       const finalWidth = data.node.parentElement?.clientWidth - offSet;
  //       return data.x / finalWidth * 100
  //     }
  //   }
  //   return 0;
  // }

  function calculatePixels(percent: number, axis: Axis) {
    console.log(parentElem.current);
    if (parentElem.current && cardElem.current) {
      if (axis === Axis.Y) {
        const offSet =
          parentElem.current?.clientHeight - cardElem.current.clientHeight;
        return (offSet * percent) / 100;
      } else if (axis === Axis.X) {
        const offSet =
          parentElem.current?.clientWidth - cardElem.current.clientWidth;
        return (offSet * percent) / 100;
      }
    }
    return 0;
  }

  useEffect(() => {
    if (parentElem.current && cardElem.current) {
      setRndState({
        ...rndState,
        position: {
          x: calculatePixels(rndState.position.x, Axis.X),
          y: calculatePixels(rndState.position.y, Axis.Y),
        },
      });
    }
    //eslint-disable-next-line
  }, [parentElem, cardElem]);

  const bindGestures = useGesture(
    {
      // onDrag: (state) => console.log(state),
      onPinch: state => {
        console.log('pinch', state);
        console.log(rndState);
        state.event.preventDefault();
        state.event.stopPropagation();

        const castedState = state as any;
        // const m = castedState.movement[0];
        const direction = castedState.direction[0];
        let distance = castedState.distance[0];
        if (direction >= 1) {
          distance = 1.02;
        } else {
          distance = 0.98;
        }
        // if (direction < 0.5){
        //   distance = 0.5;
        // }
        let newWidth = rndState.scale.w;
        let newHeight = rndState.scale.h;

        newWidth = newWidth * distance;
        newHeight = newHeight * distance;
        const differenceInWidth = rndState.scale.w - newWidth;
        const differenceInHeight = rndState.scale.h - newHeight;

        rndComponent.current?.updateSize({
          width: newWidth,
          height: newHeight,
        });

        setRndState(rndState => ({
          ...rndState,
          position: {
            x: rndState.position.x - differenceInWidth / 2,
            y: rndState.position.y - differenceInHeight / 2,
          },
          scale: {
            w: newWidth,
            h: newHeight,
          },
        }));
      },
    },
    {
      eventOptions: { passive: false },
    }
  );

  return (
    <Rnd
      ref={rndComponent}
      style={{ ...style }}
      minHeight={'30px'}
      minWidth={'30px'}
      bounds="parent"
      lockAspectRatio={lockAspectRatio}
      size={{ width: rndState.scale.w, height: rndState.scale.h }}
      position={{ x: rndState.position.x, y: rndState.position.y }}
      onDragStart={e => {
        toggleDrag();
        handleZIndex(id);
      }}
      onDragStop={(e, d) => {
        setRndState({
          ...rndState,
          position: {
            x: d.x,
            y: d.y,
          },
        });
        toggleDrag(id, e);
      }}
      onResize={() => {
        const container = cardElem.current as HTMLElement;
        if (
          container &&
          Math.abs(container.clientWidth - rndState.scale.w) > 20
        ) {
          setFontSize(container.clientWidth / 5);
        }
        // setFontSize(container.clientWidth / 5);
      }}
      onResizeStop={(e, direction, ref, delta, position) => {
        setRndState({
          scale: {
            w: ref.offsetWidth,
            h: ref.offsetHeight,
          },
          position: {
            x: position.x,
            y: position.y,
          },
        });
      }}
    >
      <MainCont
        ref={cardElem}
        {...bindGestures()}
        style={{ fontSize: `${fontSize}px` }}
      >
        {children}
      </MainCont>
    </Rnd>
  );
};

export default DragAndResizable;
